import { API_CONSULT } from 'Constants/client-modules';
import { WEBCHAT } from 'Constants/normalize-module';

import * as ACTION_TYPES from './types';

export function createPOS(consultId, body) {
  return {
    types: [
      ACTION_TYPES.POS_CREATE_REQUESTED,
      ACTION_TYPES.POS_CREATE_SUCCEED,
      ACTION_TYPES.POS_CREATE_FAILED,
    ],
    promise: client => client.post(`/consults/${consultId}/poses`, body),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      module: WEBCHAT,
    },
  };
}

export function getPOS(id) {
  return {
    types: [
      ACTION_TYPES.POS_GET_REQUESTED,
      ACTION_TYPES.POS_GET_SUCCEED,
      ACTION_TYPES.POS_GET_FAILED,
    ],
    promise: client => client.get(`/poses/${id}`),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      module: WEBCHAT,
    },
  };
}
